"use client";

import React from "react";
import { Trans } from "react-i18next";
import { Box } from "@revoo/design-system/ui/Box/Box";
import { Button } from "@revoo/design-system/ui/Button/Button";
import { Flex } from "@revoo/design-system/ui/Flex/Flex";
import { Text1 } from "@revoo/design-system/ui/Typography/Text1";
import { Icon } from "@revoo/design-system/ui/Icon/Icon";
import { Modal } from "@revoo/design-system/ui/Modal/Modal";
import { useTheme } from "@revoo/design-system/providers/ThemeProvider";
import { useDisclosureContext } from "@/libs/shared/providers/DisclosureProvider";
import { useLoginModalContext } from "@/libs/auth/components/LoginModal/LoginModalProvieder";

const LoginModal = () => {
  const { isOpen, onClose } = useDisclosureContext();
  const { colors } = useTheme();

  const { handleLoginWithCancel } = useLoginModalContext();

  const handleClick = () => {
    onClose();
    handleLoginWithCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      onClose={onClose}
      hasClosedButton={false}
      Footer={
        <Flex
          w="full"
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          <Button
            onClick={onClose}
            _focusVisible={{
              boxShadow: `inset 0px 0px 0px 2px ${colors.palette.primary[0]}`,
            }}
          >
            <Trans i18nKey="common:cancel" />
          </Button>
          <Button
            variant="outline"
            onClick={handleClick}
            _focusVisible={{
              boxShadow: `inset 0px 0px 0px 2px ${colors.palette.primary[0]}`,
            }}
          >
            <Trans i18nKey="Settings:card:delete-account:modal:confirm_button" />
          </Button>
        </Flex>
      }
      justifyContent="flex-start"
    >
      <Flex direction="column" alignItems="center">
        <Flex alignItems="center" mb={4}>
          <Icon mr={4} icon="IcDraft" color="palette.errors.50" />
          <Text1
            fontSize={{
              base: "lg",
              sm: "2xl",
            }}
            fontWeight={600}
          >
            <Trans i18nKey="Settings:billing:subscription:alert:title" />
          </Text1>
        </Flex>
        <Box
          textAlign="center"
          fontSize={{
            base: "sm",
            sm: "md",
          }}
        >
          <Trans i18nKey="Settings:card:delete-account:modal:subtitle" />
        </Box>
      </Flex>
    </Modal>
  );
};

export default LoginModal;
